import { CustomError } from "../../models/Error";
import { UPDATE_ERRORS } from "./actionTypes";
 
export const upsertErrors = (error: CustomError) => {
    return {
        type: UPDATE_ERRORS,
        payload: error
    };
};